const state = {
  airMsgSelt: null,
  stateObj: null,
  taincrMsg: null,
  reportHead: {},
  peopleType: { ADT: '成人', CHD: '儿童', INF: '婴儿' },
  PRICELABEL: {}
}

const getters = {
  airMsgSelt: state => state.airMsgSelt,
  stateObj: state => state.stateObj,
  taincrMsg: state => state.taincrMsg,
  reportHead: state => state.reportHead
}

const mutations = {
  setReportHead (state, ployed) {
    state.reportHead = ployed || {}
  },
  setAirMsgSelt (state, ployed) {
    state.airMsgSelt = ployed
  },
  setStateObj (state, ployed) {
    state.stateObj = ployed
  },
  setTaincrMsg (state, ployed) {
    state.taincrMsg = ployed
  },
  set_PRICELABEL (state, ployed) {
    state.PRICELABEL = ployed
  }
}

export default {
  state, getters, mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/manage.js